import { IntegrationServiceId } from '../../../../../common/integrations'
import { ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { CalendarSyncSettings } from './CalendarSyncSettings'
import { ContactSyncSettings } from './ContactSyncSettings'
import { CRMIntegrationTaskSettings } from '../CRMIntegrationTaskSettings'

export const SalesforceBasedSpecificSettings = (serviceId: IntegrationServiceId): ClickNavigationSection[] => {
  const baseSFSpecificSettings: ClickNavigationSection[] = [
    { id: 'contactSync', label: 'Contact Sync', content: () => <ContactSyncSettings serviceId={serviceId} /> },
    { id: 'calendarSync', label: 'Calendar Sync', content: () => <CalendarSyncSettings serviceId={serviceId} /> },
    { id: 'task', label: 'Task', content: () => <CRMIntegrationTaskSettings serviceId={serviceId} /> },
  ]
  return baseSFSpecificSettings
}
